import { API_URL } from '../../shared/constants/API.constants';

import { ROUTES as AUTH_ROUTES } from '../auth/auth.constants';

export const InternalRoutes = {
    CAMPAIGN_MANAGER: '/dashboard/overview/account',
    BILLING: '/billing',
    CAMPAIGN: '/dashboard/insights/campaign',
    CREATIVE: '/dashboard/insights/creative',
    EFFICIENCY: '/dashboard/overview/efficiency',
    MULTICHANNEL_FORECAST: '/dashboard/overview/forecast',
    HOME: '/',
    INSIGHTS: '/dashboard/insights',
    INTEGRATIONS: '/settings/integrations',
    TOP_KEYWORDS: '/dashboard/overview/keywords',
    MANAGE: '/dashboard/manage',
    NOTIFICATIONS: '/settings/notifications',
    OVERVIEW: '/dashboard/overview',
    PRICING: '/pricing',
    RISK_ANALYSIS: '/dashboard/overview/risk',
    SETTINGS: '/company',
    TEAM: '/team/',
    USER_PROFILE: '/account/profile',
    THERMOMETER: '/dashboard/overview/thermometer',
    USER_SETTINGS: '/account/settings',
    WORKFLOW: '/dashboard/manage/workflow',
    WORKFLOW_WITH_CARD_ID: '/dashboard/manage/workflow/card/:cardId',
    PARTNERSHIPS: '/partnerships',
};

export const ExternalRoutes = {
    HELP_CENTER: 'https://app.getguru.com/card/cepg9XMi/Help-Center-Pareto',
    WHAT_IS_NEW: 'http://blog.paretogroup.com.br',
    ABOUT_UPLIFY: 'https://pareto.io/pt-br/uplify/',
    CREATE_YOUR_CAMPAIGN: 'https://meetings.hubspot.com/jessicaolsi/sdrs',
    ABOUT_TESS_AI: 'https://pareto.io/pt-br/tess-ai/',
    TESS_PLATFORM_ACCESS: 'https://tess.pareto.io/pt-BR/login',
};

export const Routes = {
    AUTH: '/auth',
    AUTH_SIGN_IN: AUTH_ROUTES.SIGN_IN,
    AUTH_SIGN_OUT: AUTH_ROUTES.SIGN_OUT,
    BILLING_CENTER: '/billing',
    SIGN_UP: AUTH_ROUTES.SIGN_UP,
    SUCCESS: '/success',
    LOGIN: '/login',
    CONFIRM_RESET_PASSWORD: '/auth/reset_password/:id/:token',
    WAITING_LIST: '/waiting-list',
    POLICY_PRIVACY_AND_SERVICE_TERMS: '/policy-privacy-and-service-terms',
    SKIP_INTEGRATION: `${API_URL}/api/skip-integration`,
    USER_SIGN_UP_PENDING: AUTH_ROUTES.SPLASH_SCREEN,
    ANALYTICS_INTEGRATION: '/auth/analytics_link',
    ...InternalRoutes,
};

export default Routes;
